/* import __COLOCATED_TEMPLATE__ from './project-details-ledger-dropdown.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import clsx from 'clsx';

const CLASS_NAME = 'project-details-ledger-dropdown';
const CLASS_NAME_DISABLED = `${CLASS_NAME}--disabled`;
const BUTTON_CLASS_NAME = `${CLASS_NAME}__button`
const BUTTON_DISABLED_CLASS_NAME = `${BUTTON_CLASS_NAME}--disabled`
const COLLAPSIBLE_AREA_CLASS_NAME = `${CLASS_NAME}__collapsible-area`;
const COLLAPSIBLE_AREA_COLLAPSED_CLASS_NAME = `${COLLAPSIBLE_AREA_CLASS_NAME}--collapsed`;
const ICON_CLASS_NAME = `${CLASS_NAME}__collapse-icon`;
const ICON_DISABLED_CLASS_NAME = `${ICON_CLASS_NAME}--disabled`;

class ProjectDetailsLedgerDropdown extends Component {
  @tracked isCollapsed = true;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.args.isDisabled && CLASS_NAME_DISABLED,
    );
  }

  get buttonClasses() {
    return clsx(
      BUTTON_CLASS_NAME,
      this.args.isDisabled && BUTTON_DISABLED_CLASS_NAME,
    );
  }

  get iconClasses() {
    return clsx(
      ICON_CLASS_NAME,
      this.args.isDisabled && ICON_DISABLED_CLASS_NAME,
    );
  }

  get collapsibleAreaClasses() {
    return clsx(
      COLLAPSIBLE_AREA_CLASS_NAME,
      this.isDropdownClosed && COLLAPSIBLE_AREA_COLLAPSED_CLASS_NAME,
    );
  }

  get isDropdownClosed() {
    return this.isCollapsed || this.args.isDisabled;
  }

  @action
  onDropdownClicked() {
    if (!this.argsisDisabled) {
      this.isCollapsed = !this.isCollapsed;
    }
  }
}

export default ProjectDetailsLedgerDropdown;
